import * as logging from '@optimizely/js-sdk-logging'

import {
  DISABLE_EXPERIMENTS,
  OPTIMIZELY_CONTROL_EXPERIMENT,
  OPTIMIZELY_FORCED_VARIATIONS,
  OPTIMIZELY_VARIATIONS,
} from 'app-constants'
import { setVisitorId } from 'utils/setVisitorId'

export const shouldForceControl = () => {
  return window.sessionStorage.getItem(DISABLE_EXPERIMENTS) === 'true'
}

const logger = logging.getLogger('<OptimizelyExperiment>')

export const getForcedVariation = (experimentKey: string, visitorId: string) => {
  const forcedMap = window.sessionStorage.getItem(OPTIMIZELY_FORCED_VARIATIONS)

  if (forcedMap) {
    const forcedVariation = new Map(JSON.parse(forcedMap)).get(experimentKey)

    if (forcedVariation) {
      logger.info(
        `Forcing ${forcedVariation} variation in experiment="%s" for user="%s"`,
        experimentKey,
        visitorId,
      )

      return forcedVariation
    }
  }

  if (shouldForceControl()) {
    logger.info(
      'Forcing control variation in experiment="%s" for user="%s"',
      experimentKey,
      visitorId,
    )

    return OPTIMIZELY_CONTROL_EXPERIMENT
  }

  return null
}

export const getVariation = (experimentName: string) => {
  const forcedVariation = getForcedVariation(experimentName, setVisitorId())

  if (forcedVariation) {
    return forcedVariation
  }

  if (shouldForceControl()) {
    return OPTIMIZELY_CONTROL_EXPERIMENT
  }

  const variationsMap = window.sessionStorage.getItem(OPTIMIZELY_VARIATIONS)

  if (!variationsMap) {
    return OPTIMIZELY_CONTROL_EXPERIMENT
  }

  const map = new Map(JSON.parse(variationsMap))

  return map.get(experimentName) || OPTIMIZELY_CONTROL_EXPERIMENT
}

export const findForcedVariations = (params: object, experiments: any) => {
  const filterVariations = (forced, { key }) => {
    const variation = params[key]

    if (variation) {
      return Object.assign(forced, { [key]: variation })
    }

    if (shouldForceControl()) {
      return Object.assign(forced, { [key]: OPTIMIZELY_CONTROL_EXPERIMENT })
    }

    return forced
  }

  return experiments?.reduce(filterVariations, {}) ?? null
}
